import { NgModule, APP_INITIALIZER } from '@angular/core';

import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent, ClickStopPropagation } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';


import {FlexLayoutModule} from '@angular/flex-layout';

import {AppRouters} from './app.routes';

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { NestedMenu } from './menu';
import { NestedSidemenu } from './sidemenu';


import { WelcomeComponent } from './welcome/welcome.component';
import { ChisiamoComponent } from './chisiamo/chisiamo.component';

//import { RequestInterceptorService } from './auth/request-interceptor.service';
//import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthService, AuthGuard } from './auth/auth.service';
import { RestsService } from './rests.service';


import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatNativeDateModule} from '@angular/material';


// AREE TEMATICHE
import { MiinteressaComponent } from './miinteressa/miinteressa.component';
import { AcqueComponent } from './miinteressa/acque/acque.component';
import { AgentifisiciComponent } from './miinteressa/agentifisici/agentifisici.component';
import { AriaComponent } from './miinteressa/aria/aria.component';
import { ConservazionenaturaComponent } from './miinteressa/conservazionenatura/conservazionenatura.component';
import { EnergiaComponent } from './miinteressa/energia/energia.component';
import { RifiutiComponent } from './miinteressa/rifiuti/rifiuti.component';
import { TerritorioComponent } from './miinteressa/territorio/territorio.component';

// IO SONO
import { IosonoComponent } from './iosono/iosono.component';
import { CittadinoComponent } from './iosono/cittadino/cittadino.component';
import { ImpresaprofessionistaComponent } from './iosono/impresaprofessionista/impresaprofessionista.component';
import { OperatoreComponent } from './iosono/operatore/operatore.component';
import { DelegatoComponent } from './iosono/delegato/delegato.component';

// SERVIZI ONLINE
import { ServizionlineComponent } from './servizionline/servizionline.component';
import { CartografiaComponent } from './servizionline/cartografia/cartografia.component';
import { IndicatoriambientaliComponent } from './servizionline/indicatoriambientali/indicatoriambientali.component';
import { GestioneprocedimentiamministrativiComponent } from './servizionline/gestioneprocedimentiamministrativi/gestioneprocedimentiamministrativi.component';
import { MonitoraggiambientaliComponent } from './servizionline/monitoraggiambientali/monitoraggiambientali.component';
import { GeoportaleComponent } from './servizionline/geoportale/geoportale.component';

import { NewsComponent } from './news/news.component';

// DATI APERTI
import { DatiapertiComponent } from './datiaperti/datiaperti.component';
import { DatiCartograficiComponent } from './datiaperti/daticartografici/daticartografici.component';
import { ElenchiComponent } from './datiaperti/elenchi/elenchi.component';
import { NormativaComponent } from './datiaperti/normativa/normativa.component';

import { MappaportaleComponent } from './mappaportale/mappaportale.component';

import { ContattaciComponent } from './contattaci/contattaci.component';
import { NotelegaliComponent } from './notelegali/notelegali.component';
import { CookiesComponent } from './cookies/cookies.component';
import { PrivacyComponent } from './privacy/privacy.component';

import { HomeprivataComponent } from './homeprivata/homeprivata.component';

import { EsriMapComponent } from './esri-map/esri-map.component';
import { NotificheComponent } from './notifiche/notifiche.component';
import { IframecontainerComponent } from './iframecontainer/iframecontainer.component';
import { SafePipe } from './safe.pipe';
import { HelpdeskComponent } from './helpdesk/helpdesk.component';

export function initializeServices(auth: AuthService): Function 
{
  return () => { return auth.checkAuthentication() }; 
}

@NgModule({
  declarations: [	
    AppComponent,
    WelcomeComponent,
    NestedMenu,
    NestedSidemenu,
    ChisiamoComponent,
    MiinteressaComponent,
    IosonoComponent,
    ServizionlineComponent,
    NewsComponent,
    DatiapertiComponent,
    MappaportaleComponent,
    AcqueComponent,
    AgentifisiciComponent,
    AriaComponent,
    ConservazionenaturaComponent,
    EnergiaComponent,
    RifiutiComponent,
    TerritorioComponent,
    CittadinoComponent,
    ImpresaprofessionistaComponent,
    OperatoreComponent,
    DelegatoComponent,
    CartografiaComponent,
    IndicatoriambientaliComponent,
    GestioneprocedimentiamministrativiComponent,
    MonitoraggiambientaliComponent,
    DatiCartograficiComponent,
    ElenchiComponent,
    NormativaComponent,
    GeoportaleComponent,
    ContattaciComponent,
    NotelegaliComponent,
    CookiesComponent,
    PrivacyComponent,
    HomeprivataComponent,
    EsriMapComponent,
    NotificheComponent,
    IframecontainerComponent,
    SafePipe,
      HelpdeskComponent,
      ClickStopPropagation      
   ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpClientJsonpModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    AppRouters,
    MDBBootstrapModule,
    FormsModule,
    MaterialModule,
    MatNativeDateModule,
    ReactiveFormsModule,
  ],
  exports: [
  ],
//  entryComponents: [NestedMenu],
  providers: [
    RestsService,
    AuthService,
    AuthGuard,
    { provide: APP_INITIALIZER, useFactory: initializeServices, deps: [AuthService], multi: true },
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }


